import { Component, OnInit } from "@angular/core";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { Subscription } from "rxjs";
import { DetalleEstablecimientoService } from "./establecimiento.service";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { AuthService } from "src/app/shared/services/auth.service";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { ActividadEconomicaEntry } from "src/app/shared/entrys/actividad-economica.entry";
// tslint:disable-next-line:max-line-length
import { ModalActividadEconomicaComponent } from "src/app/components/seguridad/layouts/modal-actividad-economica/modal-actividad-economica.component";
import { PerfilService } from "src/app/components/seguridad/containers/perfil/perfil.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseServiceService } from "src/app/shared/services/base-service.service";

@Component({
  selector: "app-establecimiento",
  templateUrl: "./establecimiento.component.html",
  styleUrls: ["./establecimiento.component.scss"],
})
export class EstablecimientoComponent implements OnInit {
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  suscripcion: Subscription;
  informacionEstablecimiento: any;
  informacionEstablecimiento_anterior: any;
  tipo_rnt_inmueble = TipoRnt.Inmuebles;
  tipo_rnt_establecimiento = TipoRnt.Establecimiento;
  tipo_rnt_guia = TipoRnt.Guia;
  tipo_rnt_plataforma = TipoRnt.PlataformaDigitales;
  tipo_prestador = RolesUsuario.Prestador;
  tipo_depositario = RolesUsuario.Depositario;
  nombrePrestador: string;

  constructor(
    private dataSharedService: DataSharedService,
    private detalleEstablecimientoService: DetalleEstablecimientoService,
    public authService: AuthService,
    private modalService: NgbModal,
    private baseService: BaseServiceService
  ) {
    this.suscripcion = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });
    // this.informacionEstablecimiento = [] as Array<any>;
    this.informacionEstablecimiento_anterior = {};
    this.informacionEstablecimiento = {};
  }

  ngOnInit() {
    this.detalleEstablecimientoService
      // .getDetalleEstablecimiento_2(this.datoSolicitudSharedModel.data)
      .getDetalleEstablecimientoParaFuncionario(
        this.datoSolicitudSharedModel.data
      )
      .subscribe((res) => {
        if (res.result && res.data && res.data.length === 1) {
          this.informacionEstablecimiento = res.data[0];
          this.informacionEstablecimiento_anterior = null;
        } else {
          this.informacionEstablecimiento = res.data[0];
          this.informacionEstablecimiento_anterior = res.data[1];
        }
        this.detalleEstablecimientoService.infoEstablecimientoHistorico =
          res.data;
      });
  }

  consultarActividades() {
    this.detalleEstablecimientoService
      .sincronizacionActividadesEconimicas({
        rnt_id: this.datoSolicitudSharedModel.data.rnt_id,
        codigo_camara: this.datoSolicitudSharedModel.data.codigo_camara,
      })
      .subscribe((res) => {
        this.detalleEstablecimientoService
          .getActividadesEconomicasParaFuncionario(
            this.datoSolicitudSharedModel.data.rnt_id
          )
          .subscribe((resultado) => {
            if (resultado.result) {
              const actividadesEconomicas =
                resultado.data as Array<ActividadEconomicaEntry>;
              const modalRef = this.modalService.open(
                ModalActividadEconomicaComponent,
                {
                  centered: true,
                  size: "lg",
                  backdropClass: "light-blue-backdrop",
                }
              );
              modalRef.componentInstance.actividadesEconomicas =
                actividadesEconomicas;
              modalRef.componentInstance.tipoUsuario =
                this.authService.getTipoUser();
            }
          });
      });
  }

  // No esta funcionando
  consultarActividadesPrestador() {
    this.nombrePrestador = this.authService.getUserNameToken();

    this.baseService
      .getActividadesEconomicasPrestador(this.nombrePrestador)
      .subscribe((response) => {
        if (response.control.code == 200) {
          const actividadesEconomicas =
            response.data as Array<ActividadEconomicaEntry>;
          const modalRef = this.modalService.open(
            ModalActividadEconomicaComponent,
            {
              centered: true,
              size: "lg",
              backdropClass: "light-blue-backdrop",
            }
          );
          modalRef.componentInstance.actividadesEconomicas =
            actividadesEconomicas;
          modalRef.componentInstance.tipoUsuario =
            this.authService.getTipoUser();
        }
      });
  }

  consultarActividadesPrestadorFuncionario() {
    //this.nombrePrestador = this.authService.getUserNameToken();
    let numeroIdentificacion = this.informacionEstablecimiento.numero_identificacion || this.informacionEstablecimiento.nit;
    let digitoVerificacion = this.informacionEstablecimiento.digito_verificacion;
    this.baseService
      .getActividadesEconomicasPrestadorFuncionario(numeroIdentificacion, digitoVerificacion)
    .subscribe((response) => {
        if (response.control.code == 200) {
          const actividadesEconomicas =
            response.data as Array<ActividadEconomicaEntry>;
          const modalRef = this.modalService.open(
            ModalActividadEconomicaComponent,
            {
              centered: true,
              size: "lg",
              backdropClass: "light-blue-backdrop",
            }
          );
          modalRef.componentInstance.actividadesEconomicas =
            actividadesEconomicas;
          modalRef.componentInstance.tipoUsuario =
            this.authService.getTipoUser();
        }
      });
  }

  consultarActividadesEstablecimiento(dataEstablecimiento) {
    let numeroIdentificacion = dataEstablecimiento.numero_identificacion;
    let digitoVerificacion = dataEstablecimiento.digito_verificacion;
    let codigoCamara = dataEstablecimiento.codigo_camara;
    let numeroMatricula = dataEstablecimiento.matricula;

    this.baseService
    .getActividadesEconomicasEstablecimientos(numeroIdentificacion, digitoVerificacion, codigoCamara, numeroMatricula)
    .subscribe((response) => {
      if (response.control.code == 200) {
        const actividadesEconomicas =
          response.data as Array<ActividadEconomicaEntry>;
        const modalRef = this.modalService.open(
          ModalActividadEconomicaComponent,
          {
            centered: true,
            size: "lg",
            backdropClass: "light-blue-backdrop",
          }
        );
        modalRef.componentInstance.actividadesEconomicas =
          actividadesEconomicas;
        modalRef.componentInstance.tipoUsuario =
          this.authService.getTipoUser();
      }
    });
  }
}
